import { FC } from 'react'
import { Radio, RadioGroup } from 'rsuite'

import styles from '../../../styles/FiltersModal.module.less'

interface SortPickerMobileProps {
  options: Array<{
    label: string | React.ReactNode
    value: string
  }>
  value: string
  onChange: (value: string) => void
}

const SortPickerMobile: FC<SortPickerMobileProps> = ({ options, value, onChange }) => (
  <RadioGroup
    name="sort-options"
    value={value}
    onChange={(val) => onChange(val as string)}
  >
    {options.map((option) => (
      <Radio
        key={option.value}
        value={option.value}
        className={styles['sort-picker']}
      >
        {option.label}
      </Radio>
    ))}
  </RadioGroup>
)

export default SortPickerMobile
